<h2 mat-dialog-title class="flex items-center justify-between border-b border-outline-variant pb-2">
  <span class="text-on-surface font-bold text-lg">{{ title() }}</span>
  <button matIconButton mat-dialog-close aria-label="閉じる">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="mat-typography py-4">
  @if (isLoading()) {
    <div class="flex justify-center items-center py-8">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else if (error()) {
    <div class="p-4 bg-error-container text-on-error-container rounded-md">
      <p>天気情報の取得に失敗しました。</p>
    </div>
  } @else if (weatherData()) {
    @if (data.mode === 'weekly') {
      <div class="overflow-x-auto">
        <table class="w-full text-sm text-left border-collapse min-w-[600px]">
          <thead class="bg-surface-variant text-on-surface-variant">
            <tr>
              <th class="px-4 py-2 border-b border-outline-variant whitespace-nowrap">日付</th>
              <th class="px-4 py-2 border-b border-outline-variant whitespace-nowrap text-center">天気</th>
              <th class="px-4 py-2 border-b border-outline-variant whitespace-nowrap text-right">最高気温 (℃)</th>
              <th class="px-4 py-2 border-b border-outline-variant whitespace-nowrap text-right">最低気温 (℃)</th>
              <th class="px-4 py-2 border-b border-outline-variant whitespace-nowrap text-right">降水確率 (%)</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-outline-variant bg-surface text-on-surface">
            @for (item of mrfData(); track item.date) {
              <tr class="hover:bg-surface-variant/30 transition-colors">
                <td class="px-4 py-2 whitespace-nowrap">{{ item.date | date:'MM/dd (E)' }}</td>
                <td class="px-4 py-2 text-center">
                  <div class="flex flex-col items-center">
                    <mat-icon class="text-primary">{{ getWeatherIcon(item.wx) }}</mat-icon>
                    <span class="text-xs mt-1">{{ getWeatherText(item.wx) }}</span>
                  </div>
                </td>
                <td class="px-4 py-2 text-right text-error font-semibold">{{ item.maxtemp | number:'1.1-1' }}</td>
                <td class="px-4 py-2 text-right text-primary font-semibold">{{ item.mintemp | number:'1.1-1' }}</td>
                <td class="px-4 py-2 text-right">{{ item.pop }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      <div class="overflow-x-auto">
        <table class="w-full text-sm text-left border-collapse min-w-[600px]">
          <thead class="bg-surface-variant text-on-surface-variant">
            <tr>
              <th class="px-4 py-2 border-b border-outline-variant whitespace-nowrap">時間</th>
              <th class="px-4 py-2 border-b border-outline-variant whitespace-nowrap text-center">天気</th>
              <th class="px-4 py-2 border-b border-outline-variant whitespace-nowrap text-right">気温 (℃)</th>
              <th class="px-4 py-2 border-b border-outline-variant whitespace-nowrap text-right">降水量 (mm)</th>
              <th class="px-4 py-2 border-b border-outline-variant whitespace-nowrap text-right">風速 (m/s)</th>
              <th class="px-4 py-2 border-b border-outline-variant whitespace-nowrap text-center">風向</th>
              <th class="px-4 py-2 border-b border-outline-variant whitespace-nowrap text-right">湿度 (%)</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-outline-variant bg-surface text-on-surface">
            @for (item of srfData(); track item.date) {
              <tr class="hover:bg-surface-variant/30 transition-colors">
                <td class="px-4 py-2 whitespace-nowrap">{{ item.date | date:'HH:mm' }}</td>
                <td class="px-4 py-2 text-center">
                  <div class="flex flex-col items-center">
                    <mat-icon class="text-primary">{{ getWeatherIcon(item.wx) }}</mat-icon>
                    <span class="text-xs mt-1">{{ getWeatherText(item.wx) }}</span>
                  </div>
                </td>
                <td class="px-4 py-2 text-right font-semibold" [class.text-error]="item.temp >= 30" [class.text-primary]="item.temp <= 5">{{ item.temp | number:'1.1-1' }}</td>
                <td class="px-4 py-2 text-right">{{ item.prec | number:'1.1-1' }}</td>
                <td class="px-4 py-2 text-right">{{ item.wndspd | number:'1.1-1' }}</td>
                <td class="px-4 py-2 text-center">{{ getWindDirection(item.wnddir) }}</td>
                <td class="px-4 py-2 text-right">{{ item.rhum }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  } @else {
    <div class="p-4 text-center text-on-surface-variant">
      <p>データがありません。</p>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="border-t border-outline-variant pt-2">
  <button matButton mat-dialog-close>閉じる</button>
</mat-dialog-actions>
